import {
 ADD_DOCUMENT_SHARED_ACCESS, ADD_SIGNATURE_FAILURE, ADD_SIGNATURE_REQUEST, ADD_SIGNATURE_SUCCESS,
 AppThunk, CREATE_DOCUMENT_FAILURE, CREATE_DOCUMENT_REQUEST, CREATE_DOCUMENT_SUCCESS, DELETE_DOCUMENT_FAILURE, DELETE_DOCUMENT_REQUEST, DELETE_DOCUMENT_SUCCESS,
  FETCH_FILE_DETAILS_REQUEST, FETCH_FILE_DETAILS_SUCCESS, FETCH_RECOMMENDED_DOCUMENTS_FAILURE, FETCH_RECOMMENDED_DOCUMENTS_REQUEST, FETCH_RECOMMENDED_DOCUMENTS_SUCCESS,
  RESET_SELECTED_DOCUMENT, SELECT_DOCUMENT_FOR_EDITING, UPDATE_FOLDERS_WITH_DOCUMENTS
} from '../types';
import apis from '../../utils/apis';
import { Dispatch, AnyAction } from 'redux';
import { showFeedbackModal } from './UserFeedbackActions';
import { FileProps, FolderProps } from '../../components/Files/documents/types';
import { handleApiError } from './utils/utils';
import { translate } from '../../i18n/translate';



export const addSignatureRequest = () => ({
  type: ADD_SIGNATURE_REQUEST,
});

export const addSignatureSuccess = (signature: string) => ({
  type: ADD_SIGNATURE_SUCCESS,
  payload: signature,
});

export const addSignatureFailure = (error: string) => ({
  type: ADD_SIGNATURE_FAILURE,
  payload: error,
});


export const deleteDocumentRequest = (): { type: string } => ({
  type: DELETE_DOCUMENT_REQUEST,
});

export const deleteDocumentSuccess = (documentId: string): { type: string; payload: string } => ({
  type: DELETE_DOCUMENT_SUCCESS,
  payload: documentId,
});

export const deleteDocumentFailure = (error: string): { type: string; payload: string } => ({
  type: DELETE_DOCUMENT_FAILURE,
  payload: error,
});

export const createDocumentRequest = (): { type: string } => ({
  type: CREATE_DOCUMENT_REQUEST,
});

export const createDocumentSuccess = (document: FileProps): { type: string; payload: FileProps } => ({
  type: CREATE_DOCUMENT_SUCCESS,
  payload: document,
});

export const createDocumentFailure = (error: string): { type: string; payload: string } => ({
  type: CREATE_DOCUMENT_FAILURE,
  payload: error,
});


export const selectDocumentForEditing = (document: FileProps) => ({
  type: SELECT_DOCUMENT_FOR_EDITING,
  payload: document,
});

export const resetSelectedDocument = () => ({
  type: RESET_SELECTED_DOCUMENT,
});

export const fetchRecommendedDocumentsRequest = (): { type: string } => ({
  type: FETCH_RECOMMENDED_DOCUMENTS_REQUEST,
});

export const fetchRecommendedDocumentsSuccess = (recommendedDocuments: any[]): { type: string; payload: FileProps[] } => ({
  type: FETCH_RECOMMENDED_DOCUMENTS_SUCCESS,
  payload: recommendedDocuments,
});

export const fetchRecommendedDocumentsFailure = (error: string): { type: string; payload: string } => ({
  type: FETCH_RECOMMENDED_DOCUMENTS_FAILURE,
  payload: error,
});

export const updateFoldersWithDocuments = (folders: FolderProps[]): { type: string; payload: FolderProps[] } => ({
  type: UPDATE_FOLDERS_WITH_DOCUMENTS,
  payload: folders
});

export const fetchRecommendedDocuments = () => async (dispatch: Dispatch<AnyAction>): Promise<any> => {
  dispatch(fetchRecommendedDocumentsRequest())
  try {
    const response = await apis({
      method: "GET",
      url: "/files/recommended_files",
    });

    if (response && response.status === 200) {
      dispatch(fetchRecommendedDocumentsSuccess(response.data.RecommendedFiles));
      return Promise.resolve(response.data.RecommendedFiles);
    } else {
      handleApiError(response, dispatch)
      return Promise.reject(new Error('Failed to fetch documents'));
    }
  } catch (error) {
    handleApiError(error, dispatch)
    return Promise.reject(error);
  }
};





export const deleteDocument = (fileId: string, callback?: () => void, folderId?: string): AppThunk => async (dispatch) => {

  try {
    const response = await apis({
      method: 'POST',
      url: "/files/delete_file",
      data: { FileIDs: [fileId], FolderID: folderId || undefined }
    });

    if (response && response.status === 200) {
      dispatch(deleteDocumentSuccess(fileId));
      dispatch(showFeedbackModal({
        showModal: true,
        message: translate('Document deleted'),
        modalType: 'success',
        duration: 3000
      }));
      if (callback) callback();
    } else {
      handleApiError(response, dispatch)
    }
  } catch (error) {
    handleApiError(error, dispatch)
  }
};


export const editDocument = (FileID: string, FileName: string, Content: any, FolderID?: string, showNotification: boolean = true): AppThunk => async (dispatch) => {
  try {
    let contentString = Content;
    if (Content instanceof Blob) {
      contentString = await Content.text();
    } else if (typeof Content !== 'string') {
      contentString = String(Content);
    }

    const payload = {
      FileID,
      FileName,
      Content: contentString,
      FolderID: FolderID || ''
    };

    let response = await apis({
      method: 'POST',
      url: "/files/save-file",
      headers: { 'Content-Type': 'application/json' },
      data: payload,
    })

    if (response && response.status === 200) {
      // Only show notification if explicitly requested
      if (showNotification) {
        dispatch(showFeedbackModal({
          modalType: 'success',
          message: translate('File saved successfully'),
          showModal: true,
          duration: 3000
        }))
      }
      return true
    } else {
      if (showNotification) {
        handleApiError(response, dispatch)
      }
    }

  } catch (err) {
    if (showNotification) {
      handleApiError(err, dispatch)
    }
  }
}


export const fetchDocumentContent = (
  FileID: string,
): AppThunk<Promise<string>> => async (dispatch) => {
  try {
    let response = await apis({
      method: 'POST',
      url: 'files/get_file_html_content',
      headers: { 'Content-Type': 'application/json' },
      data: { FileID },
    });

    if (response.status === 200) {
      return response.data.html_content;
    } else {
      handleApiError(response, dispatch)
    }

  } catch (error) {
    handleApiError(error, dispatch)
  }
}

export const renameFile = (
  fileId: string,
  newFileName: string,
  folderId: string
): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: '/files/rename_file',
      data: { FileID: fileId, NewFileName: newFileName, FolderID: folderId },
    });

    if (response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: translate('File renamed'),
        modalType: 'success',
        duration: 3000,
      }));
    } else {
      handleApiError(response, dispatch)
    }
  } catch (error: any) {
    handleApiError(error, dispatch)
  }
}

export const callAddSignatureAPI = async (formData: FormData): Promise<any> => {
  try {
    const response = await apis({
      method: 'POST',
      url: 'user/upload_signature',
      data: formData
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addSignature = (signature: File) => {
  return async (dispatch: any) => {
    dispatch(addSignatureRequest());
    const formData = new FormData();
    formData.append('SignatureFile', signature);

    try {
      const response = await apis({
        method: 'POST',
        url: 'user/upload_signature',
        data: formData
      });

      if (response && response.status === 200) {
        dispatch(addSignatureSuccess(response.data.signature));
        dispatch(showFeedbackModal({
          showModal: true,
          message: translate('Signature added'),
          modalType: 'success',
          duration: 3000
        }));

      } else {
        handleApiError(response, dispatch)
      }
    } catch (error: any) {
      dispatch(addSignatureFailure(error.message));
      handleApiError(error, dispatch)
    }
  };
}
  ;
export const getSignature = () => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: 'GET',
        url: 'user/get_user_signature',
      });
      if (response && response.status === 200) {
        return response.data.SignatureSASUrl;

      } else {
        handleApiError(response, dispatch)
        return null
      }
    } catch (error: any) {
      handleApiError(error, dispatch)
    }
  };
};



export const updateDocumentOrder = (documentsWithNewOrder: any) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "/files/file-order",
        data: documentsWithNewOrder
      })
      if (response && response.status === 200) {
        dispatch(showFeedbackModal({
          showModal: true,
          message: response.data.message || 'Files Order Updated Successfully.',
          modalType: 'success',
          duration: 3000
        }));
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }
  };
};

export const updateFolderOrder = (updateFolderOrder: any) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "/files/folder-order",
        data: updateFolderOrder
      })
      if (response && response.status === 200) {
        dispatch(showFeedbackModal({
          showModal: true,
          message: response.data.message || 'Folder Order Updated Successfully.',
          modalType: 'success',
          duration: 3000
        }));
      } else {
        handleApiError(response, dispatch)
      }

    } catch (err) {
      handleApiError(err, dispatch)
    }
  };
};
export const editDocumentSharedAccess = (fileId: string, sharedAccess: string[]) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const resp = await apis({
        method: 'POST',
        url: '/files/edit_shared_access',
        data: { FileID: fileId, SharedWith: sharedAccess },
      });

      if (resp && resp.status === 200) {
        dispatch({ type: ADD_DOCUMENT_SHARED_ACCESS, payload: { fileId, sharedAccess } });
        // dispatch(
        //   showFeedbackModal({
        //     showModal: true,
        //     message: resp.data.message || 'Access updated',
        //     modalType: 'success',
        //     duration: 3000,
        //   }) as any
        // );
        return true;
      } else {
        handleApiError(resp, dispatch)
      }
    } catch (error) {
      handleApiError(error, dispatch)
    }
  };
};


export const fetchFileDetails = (fileId: string, folderID?: string, parentFolderID?: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: FETCH_FILE_DETAILS_REQUEST });
    try {
      const requestData: any = { FileID: fileId, FolderID: folderID || '' };
      if (parentFolderID) {
        requestData.ParentFolderID = parentFolderID;
      }
      
      const resp = await apis({
        method: 'POST',
        url: '/files/get-file',
        data: requestData,
      });

      if (resp && resp.status === 200) {
        const fileData = resp.data;
        dispatch({ type: FETCH_FILE_DETAILS_SUCCESS, payload: fileData });
        return fileData;
      } else {
        handleApiError(resp, dispatch)
        return null;
      }
    } catch (error: any) {
      handleApiError(error, dispatch)
    }
  };
};


export const downloadFile = (fileId: string): AppThunk => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: '/files/download_file',
      data: { FileID: fileId }
    });

    if (response && response.status === 200) {
      const downloadUrl = response.data.SAS_URL[1] || response.data.SAS_URL[1]; 
      const fileName = response.data.SAS_URL[0] || 'document'; 

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch({ type: 'DOWNLOAD_DOCUMENT_SUCCESS' });
    } else {
      handleApiError(response, dispatch)
    }
  } catch (error: any) {
    handleApiError(error, dispatch)
  }
};


export const updateSharedWithForFile = (FileID: string, updatedSharedWith: any[]): AppThunk => async (dispatch) => {
  try {

    let response = await apis({
      method: 'POST',
      url: "/files/update_file_sharedwith",
      data: {
        FileID,
        updatedSharedWith
      },
    })

    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        modalType: 'success',
        message: translate('File updated'),
        showModal: true,
        duration: 3000
      }))
      return true
    } else {
      handleApiError(response, dispatch)
    }

  } catch (err) {
    handleApiError(err, dispatch)
  }
}

/**
 * Stream a file from the backend with decryption happening server-side
 * Uses the global BlobStreamingService for consistent, secure file handling
 * Returns a blob that can be displayed inline or downloaded
 */
export const streamFile = (
  fileId: string,
  filename: string,
  disposition: 'inline' | 'attachment' = 'inline',
  folderId?: string,
  parentFolderId?: string,
  originalMimeType?: string,
  format?: 'original' | 'pdf'
): AppThunk<Promise<{ success: boolean; blob?: Blob; contentType?: string; filename?: string; error?: string }>> =>
  async (dispatch) => {
    try {
      const requestData: any = {
        FileID: fileId,
        Disposition: disposition,
        // Always include FolderID for consistency (empty string for root files)
        FolderID: folderId || ''
      };
      
      // Pass parent folder ID for nested folder support
      if (parentFolderId) {
        requestData.ParentFolderID = parentFolderId;
      }

      // Request format conversion (e.g. DOCX → PDF)
      if (format && format !== 'original') {
        requestData.Format = format;
      }

      const response = await apis({
        method: 'POST',
        url: '/files/stream-file',
        data: requestData,
        responseType: 'blob'
      });


      if (!response) {
        return {
          success: false,
          error: 'No response from server'
        };
      }

      if (response.status !== 200) {
        return {
          success: false,
          error: `Server returned status ${response.status}`
        };
      }

      const blob = response.data;

      if (!blob || !(blob instanceof Blob)) {
        return {
          success: false,
          error: 'Invalid file content received from server'
        };
      }

      if (blob.size === 0) {
        return {
          success: false,
          error: 'File is empty or could not be retrieved'
        };
      }

      // For DOCX files, the backend converts to HTML and returns text/html.
      // Detect DOCX via: filename extension OR original MIME type from get-file API.
      // Matter documents may have no extension (e.g. "Answer") but their FileType
      // is "application/vnd.openxmlformats-officedocument.wordprocessingml.document".
      const lowerName = filename.toLowerCase();
      const lowerMime = (originalMimeType || '').toLowerCase();
      const isDocx = lowerName.endsWith('.docx') || lowerName.endsWith('.doc')
        || lowerMime.includes('wordprocessingml') || lowerMime.includes('msword');
      if ((blob.type === 'text/html' || blob.type.includes('text/html') || blob.type === '') && !isDocx) {
        return {
          success: false,
          error: 'Server returned an error. File may not exist or access was denied.'
        };
      }

      const contentType = ((response.headers['content-type'] as string) || '').toLowerCase().trim() || 'application/octet-stream';

      let streamFilename = filename;
      const disposition_header = response.headers['content-disposition'];
      if (disposition_header) {
        const filenameMatch = disposition_header.match(/filename[^;=\n]*=(?:(['"]).*?\1|[^;\n]*)/);
        if (filenameMatch) {
          streamFilename = filenameMatch[1]?.replace(/['"]/g, '') || filename;
        }
      }


      return {
        success: true,
        blob,
        contentType,
        filename: streamFilename
      };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Error streaming file'
      };
    }
  };
